import { ReactNode } from 'react';
import { SkeletonBar } from './States';

export interface KpiCell {
  label: string;
  value: ReactNode;
  note?: ReactNode;
}

/** A row of standalone figures: serif number above a small label, no borders. */
export function KpiBand({ cells, loading = false }: { cells: KpiCell[]; loading?: boolean }) {
  return (
    <div className="flex flex-wrap gap-x-12 gap-y-6 max-md:gap-x-8 max-md:gap-y-4 mt-2 mb-4">
      {cells.map((c, i) => (
        <div key={c.label} className="min-w-[96px]">
          {loading ? (
            <div className="flex flex-col gap-3 py-1 w-[120px]">
              <SkeletonBar width="55%" delay={i * 0.05} />
              <SkeletonBar width="80%" delay={i * 0.05 + 0.15} />
            </div>
          ) : (
            <>
              <div className="font-serif tabular text-[32px] leading-9 text-ink max-md:text-[26px] max-md:leading-[30px]">
                {c.value}
              </div>
              <div className="text-small text-ink-3">{c.label}</div>
              {c.note ? <div className="text-small text-ink-3">{c.note}</div> : null}
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export function MiniKpiGrid({ cells }: { cells: (KpiCell & { chip?: ReactNode })[] }) {
  return (
    <div className="flex flex-wrap gap-x-12 gap-y-6 max-md:gap-x-8 max-md:gap-y-4">
      {cells.map((c) => (
        <div key={c.label} className="min-w-[96px]">
          <div className="font-serif tabular text-[32px] leading-9 text-ink max-md:text-[26px] max-md:leading-[30px]">
            {c.value}
          </div>
          <div className="text-small text-ink-3">{c.label}</div>
          {c.chip ? <div className="mt-1">{c.chip}</div> : null}
        </div>
      ))}
    </div>
  );
}
